var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    _vm._g(
      _vm._b(
        {
          key: _vm.index,
          ref: "dialog",
          staticClass: "ds-dialog dsf-dataview-dialog",
          class: _vm.elClass,
          attrs: { index: _vm.index, "append-to-body": "" },
          scopedSlots: _vm._u(
            [
              {
                key: "default",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "dsf-dataview-dialog-content",
                        style: _vm.wrapStyle,
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "dsf-dataview-dialog-title",
                            style: _vm.titleStyle,
                          },
                          [
                            _c("span", [_vm._v(_vm._s(_vm.title))]),
                            _c("i", {
                              staticClass: "iconfont icon-icon-close",
                              style: _vm.iconStyle,
                              on: { click: _vm.close },
                            }),
                          ]
                        ),
                        _c(
                          "DsfVirtualScroll",
                          { style: _vm.contentHeight },
                          [_vm._t("default")],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        "el-dialog",
        _vm.$attrs,
        false,
        true
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }